import {
  createFileRoute,
  Outlet,
  redirect,
  useLocation,
} from '@tanstack/react-router';

import logoJaimy from '@assets/logo-jaimy.png';
import { ScrollArea } from '@components/ui/scroll-area';
import { Separator } from '@components/ui/separator';
import { defaultAuthenticatedPath } from '@constants/auth.constant';

export const Route = createFileRoute('/_auth-layout')({
  beforeLoad: ({ context }) => {
    if (context.auth.isAuthenticated) {
      throw redirect({ href: defaultAuthenticatedPath, replace: true });
    }
  },
  component: AuthLayout,
});

function AuthLayout() {
  const { pathname } = useLocation();
  const { description, title } =
    titleAndDescriptionByPathname[pathname] ??
    titleAndDescriptionByPathname['/login'];

  return (
    <div className="bg-background relative">
      <ScrollArea className="h-dvh bg-transparent">
        <main className="grid min-h-dvh w-full place-items-center px-4 py-10">
          <section className="shadow-raised w-full max-w-xl rounded-[28px] bg-white px-10 py-12 md:px-16 md:py-14">
            <div className="grid">
              <div className="mb-14 grid">
                {/* <img
                  alt="Logo Fixxer Voice Agent"
                  className="relative mb-4 w-auto md:h-5"
                  src={logoHorizontal}
                /> */}

                <h1 className="text-primary-dark-one text-3xl font-semibold">
                  {title}
                </h1>
                <p className="text-primary-dark-one mt-1 font-light">
                  {description}
                </p>

                <div className="mt-6 flex items-center gap-x-6">
                  <span className="text-input flex whitespace-nowrap">
                    Your company
                  </span>
                  <Separator variant="auth" />
                  <img alt="Jaimy logo" className="max-w-32" src={logoJaimy} />
                </div>
              </div>

              <Outlet />
            </div>
          </section>
        </main>
      </ScrollArea>
    </div>
  );
}

const titleAndDescriptionByPathname: Record<
  string,
  { description: string; title: string }
> = {
  '/login': {
    title: 'Log in to your account',
    description: 'Welcome back!',
  },
  '/forgot-password': {
    title: 'Reset my password',
    description:
      'Enter your email address and we will send you an email to reseet your password.',
  },
  '/reset-password': {
    title: 'Set a new password',
    description: 'Please enter your new password',
  },
};
